import { MonitoringView } from "@/components/MonitoringView";

/** Submenu Monitoring Proyek → Monitoring Area (tabel per area produksi → proyek, vendor di area) */
export default function MonitoringArea() { return <MonitoringView group="area" />; }
